import classNames from 'classnames';
import { observer } from 'mobx-react';

import { OptionVariationData } from '../../../../data/model';
import { FabricFacetFiltersTranslation } from '../../../../localization/SiteTranslation';
import Accordion from '../../../../shared/components/Accordion/Accordion';
import SecondaryButton from '../../../../shared/components/Button/SecondaryButton';
import TertiaryButton from '../../../../shared/components/Button/TertiaryButton';
import CustomScrollbar from '../../../../shared/components/CustomScrollbar/CustomScrollbar';
import Icon from '../../../../shared/components/Icon/Icon';
import Modal from '../../../../shared/components/Modal/Modal';
import { Subtitle1 } from '../../../../shared/components/Typography/Subtitle';
import ColorFacetFilterState from '../FabricFacetFiltersDropdowns/ColorFacetFilter/ColorFacetFilterState';
import { filterOptionNameResolver, filterTitleResolver } from '../filterNameResolver';
import ColorFacetFilter from './ColorFacetFilter/ColorFacetFilter';
import css from './FabricFacetFiltersModal.css';
import FabricFacetFiltersModalState from './FabricFacetFiltersModalState';
import FacetFilter from './FacetFilter/FacetFilter';

interface FabricFacetFiltersModalProps {
  state: FabricFacetFiltersModalState;
  className?: string;
  translation: FabricFacetFiltersTranslation;
  allItems: Array<OptionVariationData>;
}

const FabricFacetFiltersModal = ({
  className,
  state,
  translation,
  allItems: selectedItems,
}: FabricFacetFiltersModalProps) => {
  return (
    <>
      <button
        type="button"
        className={classNames(css.trigger, { [css.active]: state.selection.properties.any() }, className)}
        onClick={state.open}
      >
        <Icon name="filters" className={css.icon} />
        {translation.openFiltersButtonLabel}
      </button>
      <Modal
        className={css.modal}
        headerWrapperClassName={css.header}
        closeButtonClassName={css.close}
        contentClassName={css.content}
        modal={state}
        headerComponent={
          <Subtitle1 small mediumBold>
            {translation.openFiltersButtonLabel}
          </Subtitle1>
        }
        fullScreen
      >
        <CustomScrollbar>
          <div className={css.acordionsContainer}>
            {/* TODO: Move to a separate component */}
            {state.filters.map((s) => {
              if (s instanceof ColorFacetFilterState) {
                return (
                  <FabricFacetFiltersModalSection title={translation.colorFilterLabel} key={s.data.name}>
                    <ColorFacetFilter state={s} allItems={selectedItems} />
                  </FabricFacetFiltersModalSection>
                );
              }
              return (
                <FabricFacetFiltersModalSection title={filterTitleResolver(s.data, translation)} key={s.data.name}>
                  <FacetFilter state={s} selectedItems={selectedItems} translation={translation} />
                </FabricFacetFiltersModalSection>
              );
            })}
          </div>
        </CustomScrollbar>
        <div className={css.footer}>
          <SecondaryButton type="submit" onClick={() => state.apply()}>
            {translation.applyFiltersButtonLabel}
          </SecondaryButton>
          <TertiaryButton type="button" onClick={() => state.clearAll()}>
            {translation.clearAllFiltersButtonLabel}
          </TertiaryButton>
        </div>
      </Modal>
    </>
  );
};

export default observer(FabricFacetFiltersModal);

interface FabricFacetFiltersModalSectionProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

const FabricFacetFiltersModalSection = ({ title, children }: FabricFacetFiltersModalSectionProps) => {
  return (
    <Accordion className={css.accordion} title={<Subtitle1 mediumBold>{title}</Subtitle1>}>
      {children}
    </Accordion>
  );
};
